import BinTimeModal from "../../components/ui/BinTimeModal";
import { getReviewerNames } from "../../helpers/reviewerOptions";
import { getPortalCompanyId, hasReviewerAdminAccess } from "../../helpers/portalAccess";
import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import moment from "moment";
import "jspdf-autotable";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import formatDate, {
  ConfirmationAlert,
  customStyles,
  errorAlert,
  formatDateWithWeekday,
  formatLetterDate,
  formatMonthDate,
  successAlert,
} from "../../utils/services";
import Select from "react-select";
import { BiDuplicate, BiSolidHide } from "react-icons/bi";
import { TbDiscount, TbDiscount2Off, TbDiscountOff } from "react-icons/tb";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Button,
  Typography,
  IconButton,
  Snackbar,
  TablePagination,
  TextField,
  Modal,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import {
  AttachMoney,
  Discount,
  Download,
  Email,
  MoneyOffCsred,
  FolderOutlined,
  Update,
} from "@mui/icons-material";
import axiosInstance from "../../helpers/axios";
import "./Timespent.css";
import CustomButton from "../../components/ui/CustomButton";
import CustomTooltip from "../../components/ui/CustomTootltip";
import NoDataFound from "../../components/NoDataFound";
import CustomDateRangePicker from "../../components/ui/CustomDateRangePicker";
import { IoMdEye } from "react-icons/io";
import CustomModal from "../../components/ui/CustomModal";
import DriveFileMoveOutlinedIcon from "@mui/icons-material/DriveFileMoveOutlined";
import { RiDeleteBin6Line } from "react-icons/ri";
import { CiEdit } from "react-icons/ci";
import DiscountModal from "../../components/ui/DiscountModal";
import { fetchDesignations } from "../../store/slices/globalSlice";
import { fetchAllMatters } from "../../store/slices/matterSlice";
import { fetchEmployees } from "../../store/slices/employeesSlice";
import { fetchCurrencySettings } from "../../actions/currencyActions";
import { Switch, FormControlLabel, Box } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import HistoryIcon from "@mui/icons-material/History";
import FilterListIcon from "@mui/icons-material/FilterList";
import { HiSparkles } from "react-icons/hi2";
import { TfiReload } from "react-icons/tfi";

const TimeSpent = () => {
  //constants
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const allCurrencyData = useSelector((state) => state.currency);
  const { filteredEmployees, employees: allEmployees, tsEmployees: employees } = useSelector(
    (state) => state.employee
  );
  const { matters, filteredMatters } = useSelector((state) => state.matter);

  useEffect(() => {
    dispatch(fetchAllMatters());
    dispatch(fetchEmployees());
    dispatch(fetchDesignations());
    dispatch(fetchCurrencySettings());
    // getRecentWorkHourByAdminId();
  }, [dispatch]);

  const [reviewerModalOpen, setReviewerModalOpen] = useState(false);
  const [selectedReviewer, setSelectedReviewer] = useState(null);
  const [reviewerReportBusy, setReviewerReportBusy] = useState(false);
  const [reviewerReportProgress, setReviewerReportProgress] = useState("");
  const reviewerReportLock = useRef(false);
  const { matterLoading, error: matterError } = useSelector((state) => state.matter);
  const isReviewerLogin = hasReviewerAdminAccess(auth.user);
  const loggedInReviewerName = auth.user?.fullName?.trim() || "";
  const reviewerOptions = useMemo(() =>
    (isReviewerLogin
      ? (loggedInReviewerName ? [loggedInReviewerName] : [])
      : getReviewerNames(allEmployees, "Partner"))
      .map((name) => ({ value: name, label: name })),
    [allEmployees, isReviewerLogin, loggedInReviewerName]);
  const reviewerMatters = useMemo(() => matters
    .filter((item) => item.status === "enable" && selectedReviewer && (
      item.reviewer?.trim() === selectedReviewer.value ||
      item.initialReviewer?.trim() === selectedReviewer.value
    ))
    .sort((a, b) => a.name.localeCompare(b.name)), [matters, selectedReviewer]);

  const [binEntries, setBinEntries] = useState([]);
  const [binBusy, setBinBusy] = useState(false);
  const binRequestLock = useRef(false);

  const [dateGroupView, setDateGroupView] = useState(false);

  const [filteredWorkHour, setFilteredWorkHour] = useState([]);
  const [writeOffHours, setWriteOffHours] = useState([]);

  const [totalAmountForSelectedPeriod, setTotalAmountForSelectedPeriod] =
    useState("0");
  const [totalHoursForSelectedPeriod, setTotalHoursForSelectedPeriod] =
    useState("0");
  const [lastSentInvoiceDate, setLastSentInvoiceDate] = useState("");
  const [totalUnbilledAmount, setTotalUnbilledAmount] = useState("0");

  const commonNames = useMemo(() => {
    return employees.map((item) => item.fullName).sort();
  }, [employees]);

  let sendMail = false;
  const adminId = getPortalCompanyId(auth.user);

  //states
  const [companyData, setCompanyData] = useState({
    companyName: "",
    companyEmail: "",
    companyAddress: "",
    companyLogo: null,
  });

  const [client, setClient] = useState("");
  const [matter, setMatter] = useState(""); //matter id
  const [selectedMatterName, setSelectedMatterName] = useState("");
  const [selectedLawyer, setSelectedLawyer] = useState("");
  const [startSelectedDate, setStartSelectedDate] = useState(() => {
    const today = new Date();
    const pastDate = new Date(today.setDate(today.getDate() - 2));
    return formatDate(pastDate);
  });
  const [endSelectedDate, setEndSelectedDate] = useState(
    formatDate(new Date())
  );

  // Filters handed over by the AI assistant ("prepare PDF"); the user still presses Download.
  const agentLocation = useLocation();
  const agentNavigate = useNavigate();
  const agentPdf = agentLocation.state?.agentPdf;
  const agentPdfStarted = useRef(null);
  useEffect(() => {
    if (!agentPdf || agentPdfStarted.current === agentPdf) return;
    agentPdfStarted.current = agentPdf;
    setStartSelectedDate(agentPdf.fromDate);
    setEndSelectedDate(agentPdf.toDate);
    if (agentPdf.kind === "master") {
      setSelectedReviewer(isReviewerLogin ? reviewerOptions[0] || null : null);
      setReviewerModalOpen(true);
      dispatch(fetchAllMatters());
      agentNavigate(agentLocation.pathname, { replace: true, state: null });
    }
  }, [agentPdf, agentLocation.pathname, agentNavigate, dispatch, isReviewerLogin, reviewerOptions]);
  useEffect(() => {
    if (!agentPdf || agentPdf.kind !== "timespent") return;
    const option = filteredMatters.find((item) => item.value === agentPdf.matterId);
    if (!option) return;
    setMatter(option.value);
    setSelectedMatterName(option.label.split("|")[0]);
    setClient(option.label.split("|")[1]);
    agentNavigate(agentLocation.pathname, { replace: true, state: null });
  }, [agentPdf, filteredMatters, agentLocation.pathname, agentNavigate]);
  const [showComment, setShowComment] = useState(false);
  const [showDiscount, setShowDiscount] = useState(false);
  const [rightOffPdfEnabled, setRightOffPdfEnabled] = useState(false);
  const [workHour, setWorkHour] = useState(0);
  const [workMin, setWorkMin] = useState(30);
  const descRef = useRef(null);
  const [workDescription, setWorkDescription] = useState("");
  const [comments, setComments] = useState("");
  const [entryId, setEntryId] = useState("");

  //add and edit time modal states
  const [showModal, setShowModal] = useState(false);
  const [editingTime, setEditingTime] = useState(null);
  const [date, setDate] = useState(formatDate(new Date()));
  const [modalClient, setModalClient] = useState("");
  const [modalMatter, setModalMatter] = useState(""); //matter id
  const [modalSelectedMatterName, setModalSelectedMatterName] = useState("");
  const [modalSelectedLawyerName, setModalSelectedLawyerName] = useState("");
  const [modalSelectedLawyerId, setModalSelectedLawyerId] = useState("");
  const [addressedComments, setAddressedComments] = useState({});
  // const [advanceAmount, setAdvanceAmount] = useState(0);

  const [loading, setLoading] = useState(false);

  //Email states
  const [emailModalOpen, setEmailModalOpen] = useState(false);
  const [email, setEmail] = useState("");

  //pagination states
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [opeWorkHours, setOpeWorkHours] = useState([]);
  const ope = useMemo(() => {
    const nativeCurrency = allCurrencyData.nativeCurrencyCode || "INR";
    const targetCurrency =
      matters.find((item) => item._id === matter)?.currency || nativeCurrency;
    const getRateToNative = (currencyCode) => {
      if (currencyCode.toUpperCase() === nativeCurrency.toUpperCase()) return 1;
      return Number(
        allCurrencyData.conversionRates?.find(
          (rate) => rate.currencyCode?.toUpperCase() === currencyCode.toUpperCase()
        )?.rate
      );
    };
    const targetRate = getRateToNative(targetCurrency);

    return opeWorkHours.reduce((total, expense) => {
      const sourceCurrency = expense.currency || nativeCurrency;
      const sourceRate = getRateToNative(sourceCurrency);
      const amount = parseFloat(expense.amount?.$numberDecimal || expense.amount || 0);
      return Number.isFinite(sourceRate) && Number.isFinite(targetRate)
        ? total + (amount * sourceRate) / targetRate
        : total;
    }, 0);
  }, [allCurrencyData, matter, matters, opeWorkHours]);
  const needFin = false;
  const [totalCount, setTotalCount] = useState(0);

  //multiple selection entries states
  const [selectedEntries, setSelectedEntries] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [newClient, setNewClient] = useState("");
  const [newMatter, setNewMatter] = useState(""); //matter id
  const [newSelectedMatterName, setNewSelectedMatterName] = useState("");

  const [singleDeleteSnackbarOpen, setSingleDeleteSnackbarOpen] =
    useState(false);
  const [multipleDeleteSnackbarOpen, setMultipleDeleteSnackbarOpen] =
    useState(false);
  const [singleWriteoffSnackbarOpen, setSingleWriteoffSnackbarOpen] =
    useState(false);
  const [multipleWriteoffSnackbarOpen, setMultipleWriteoffSnackbarOpen] =
    useState(false);

  // Store deleted and write-off items
  const [deletedItem, setDeletedItem] = useState(null); // For single delete
  const [deletedEntries, setDeletedEntries] = useState([]); // For multiple delete
  const [writeoffItem, setWriteoffItem] = useState(null); // For single write-off
  const [writeoffEntries, setWriteoffEntries] = useState([]); // For multiple write-off

  const [selectedItemWorkHours, setSelectedItemWorkHours] = useState("");
  const [recentEntries, setRecentEntries] = useState(false);

  //formatted date constants
  const formattedStartDate = formatLetterDate(startSelectedDate);
  const formattedEndDate = formatLetterDate(endSelectedDate);

  // states and functions for date range picker
  const [selectedDateRange, setSelectedDateRange] = useState({
    start: "",
    end: "",
  });

  const [openDiscountModal, setOpenDiscountModal] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);

  //AI states
  const [aiSuggestion, setAiSuggestion] = useState("");
  const [isRetryingAi, setIsRetryingAi] = useState(false); // New state to track retries

  // Function to fetch AI suggestion
  const getAiSuggestion = async (workDescription, isDescriptive = false) => {
    try {
      const response = await axiosInstance.post(`/ai/suggest`, {
        workDescription,
        isDescriptive, // Pass the descriptive flag to the backend
      });
      return response.data.aiSuggestedDescription;
    } catch (error) {
      console.error("Error fetching AI suggestion:", error);
      errorAlert("Failed to get AI suggestion. Please try again.");
      return "";
    }
  };

  // AI submit handler
  const redraftWithAI = async () => {
    if (
      date &&
      modalMatter &&
      workDescription &&
      workHour !== "" &&
      workMin !== ""
    ) {
      const suggestion = await getAiSuggestion(workDescription, false);
      setAiSuggestion(suggestion);
      setIsRetryingAi(false); // Reset retry state
    } else {
      errorAlert("All Fields are Required!");
    }
  };

  // Function to retry AI suggestion
  const retryAiSuggestion = async () => {
    if (aiSuggestion) {
      setIsRetryingAi(true); // Set retry state to true
      const newSuggestion = await getAiSuggestion(aiSuggestion, false); // Fetch a new suggestion based on current aiSuggestion
      setAiSuggestion(newSuggestion); // Update the AI suggestion
      setIsRetryingAi(false); // Reset retry state after fetching
    } else {
      errorAlert("No AI suggestion available to retry.");
    }
  };

  // Submit with AI suggestion
  const onSubmitWithAiSuggestion = async () => {
    if (
      date &&
      modalMatter &&
      aiSuggestion &&
      workHour !== "" &&
      workMin !== ""
    ) {
      const timeData = {
        admin: auth?.user?.company,
        user: modalSelectedLawyerId,
        workDate: date,
        matter: modalMatter,
        workDescription: aiSuggestion, // Use the AI suggestion
        comments,
        workHour: `${workHour}.${workMin * (10 / 6)}`,
        reviewed: true,
      };

      try {
        if (editingTime) {
          // Update the existing entry with AI suggestion
          const response = await axiosInstance.put(
            `/workHour/update/${entryId}`,
            timeData
          );

          if (response.data) {
            successAlert("Time Updated Successfully with AI Suggestion!");

            setShowModal(false);
            filterBetweenDates();
          }
          setAiSuggestion("");
          setIsRetryingAi(false);
        } else {
          // Create a new entry with AI suggestion
          const response = await axiosInstance.post(
            `/workHour/createNew`,
            timeData
          );

          if (response.data) {
            successAlert("Time Added Successfully with AI Suggestion!");
            setShowModal(false);
            filterBetweenDates();
          }
        }
      } catch (error) {
        console.error(
          "Error adding or updating time with AI suggestion:",
          error
        );
        errorAlert("Error adding or updating time with AI suggestion");
      }
    } else {
      errorAlert("All Fields are Required!");
    }
  };

  const link1Text = companyData.companyAccountsEmail;
  const link1URL = `mailto:${companyData.companyAccountsEmail}`;
  const link2Text = companyData.companyWebsite;
  const link2URL = companyData.companyWebsite;

  const columns = [
    "Date",
    "Associate",
    // "Matter",
    "Description",
    "Time",
    // "Discount hrs",
    "Edit",
    "Disc",
    "W/O",
    "Bin",
    "Duplicate",
  ];

  const totalDiscount = writeOffHours.reduce(
    (total, entry) => total + parseFloat(entry.discountedHours),
    0
  );

  // Function to receive selected dates from DateRangePickerTst
  const handleDateRangeChange = (startDate, endDate) => {
    setSelectedDateRange({ start: startDate, end: endDate });
    setStartSelectedDate(startDate);
    setEndSelectedDate(endDate);
    // console.log(startDate, endDate);
  };

  // handle blur event for description input
  const handleBlur = () => {
    if (descRef.current) {
      setWorkDescription(descRef.current.value);
    }
  };

  //pagination functions
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const fetchCompanyDetails = useCallback(async () => {
    try {
      const { data } = await axiosInstance.get(`/company/details/${adminId}`);

      setCompanyData((prevData) => ({
        ...prevData,
        companyName: data.companyName || "",
        companyEmail: data.companyEmail || "",
        companyAddress: data.companyAddress || "",
        companyLogo: data.companyLogo || "",
        companyWebsite: data.companyWebsite || "",
        companyAccountsEmail: data.companyAccountsEmail || "",
      }));
    } catch (error) {
      errorAlert("Error in fetching company details!!");
    }
  }, [adminId, setCompanyData]);

  /** overwrite every counter + grid with one response object */
  const paintScreen = ({
    workHours = [],
    totalFilteredWorkHours = 0,
    totalAmount = 0,
    totalHours = 0,
    unbilledAmount = 0,
    lastInvoiceDate = "",
  }) => {
    setFilteredWorkHour(workHours);
    setTotalCount(totalFilteredWorkHours);
    setTotalAmountForSelectedPeriod(totalAmount);
    setTotalHoursForSelectedPeriod(totalHours);
    setTotalUnbilledAmount(unbilledAmount);
    setLastSentInvoiceDate(lastInvoiceDate);
  };

  const getRecentWorkHourByAdminId = async () => {
    try {
      const { data } = await axiosInstance.get(
        "/workHour/getRecentWorkHourByAdminId",
        {
          params: { adminId, excludeBinned: true, limit: rowsPerPage, page },
        }
      );
      paintScreen(data);
    } catch {
      errorAlert("Error fetching recent work-hours");
    }
  };

  const filterBetweenDates = useCallback(async () => {
    try {
      const [workHourResponse, opeResponse] = await Promise.all([
        axiosInstance.get("/workHour/filterWorkHourByUserId", {
          params: {
            user: selectedLawyer,
            fromDate: startSelectedDate,
            toDate: endSelectedDate,
            matterId: matter,
            needFin,
            sendMail,
            adminId,
            excludeBinned: true,
            limit: rowsPerPage,
            page,
          },
        }),
        axiosInstance.get("/expense/web/admin", {
          params: {
            user: selectedLawyer,
            fromDate: startSelectedDate,
            toDate: endSelectedDate,
            matterId: matter,
            adminId,
            billableOnly: true,
          },
        }),
      ]);

      /* 🔸 A matter was chosen but nothing matched? ➜ fall back to recent. */
      // if (data.workHours.length === 0) {
      //   return getRecentWorkHourByAdminId();
      // }

      /* 🔸 Happy path – show the filtered result. */
      paintScreen(workHourResponse.data);
      setOpeWorkHours(opeResponse.data.expenses || []);
    } catch {
      errorAlert("Error fetching filtered work-hours");
    }
  }, [
    matter,
    startSelectedDate,
    selectedLawyer,
    endSelectedDate,
    needFin,
    sendMail,
    adminId,
    rowsPerPage,
    page,
  ]);

  //GET - discounted hours
  const getWriteoffHours = useCallback(async () => {
    const adminId = getPortalCompanyId(auth.user);

    if (showDiscount) {
      try {
        const { data } = await axiosInstance.get(
          `/writeoffs/getWriteoffHoursByAdmin`,
          {
            params: {
              adminId,
              user: selectedLawyer,
              fromDate: startSelectedDate,
              toDate: endSelectedDate,
              matterId: matter,
              limit: 0,
              page: 0,
            },
          }
        );

        setWriteOffHours(data.workHours);
        // setTotalCount(data.totalCount);
      } catch (error) {
        errorAlert(
          error.response?.data?.error ||
            "An error occurred in fetching writeoff hours."
        );
      }
    }
  }, [
    getPortalCompanyId(auth.user),
    showDiscount,
    selectedLawyer,
    startSelectedDate,
    endSelectedDate,
    matter,
  ]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await fetchCompanyDetails();
      } catch (error) {
        console.error("Error fetching company details:", error);
      }
    };

    fetchData();
  }, [fetchCompanyDetails]);

  useEffect(() => {
    if (showDiscount) {
      getWriteoffHours();
    } else {
      setWriteOffHours([]);
    }
  }, [getWriteoffHours, showDiscount]);

  /** choose the right endpoint whenever the inputs change */
  useEffect(() => {
    if (!startSelectedDate || !endSelectedDate) return; // dates not ready

    filterBetweenDates();
    setRecentEntries(false);
  }, [
    matter,
    startSelectedDate,
    endSelectedDate,
    page,
    rowsPerPage,
    filterBetweenDates,
  ]);

  let currency;
  const matterCurr = matters.find((m) => m._id === matter);
  if (matterCurr) {
    currency = matterCurr.currency + " ";
  } else {
    currency = "";
  }

  const onhandleApplyDiscount = async (entryId, discountValue) => {
    if (discountValue !== undefined) {
      try {
        const response = await axiosInstance.put(
          `/workhour/admin/updateWithDiscount`,
          { entryId, discountedWorkHours: discountValue }
        );

        // Check if the update was successful
        if (response.data) {
          await filterBetweenDates();
          if (showDiscount) await getWriteoffHours();

          successAlert(response.data.message);
        } else {
          // Handle update failure
          errorAlert("Applying discount failed", "Please try again...");
        }
      } catch (error) {
        // Handle other errors
        console.error("Error applying discount:", error);
        errorAlert(
          (error.message && error.message) || "Applying discount failed",
          "Please try again..."
        );
      }
    }
  };

  const reportMatterId = matter;
  const reportMatterName = selectedMatterName;
  const reportClient = client;
  const selectedLawyerForReport = selectedLawyer;
  const reportStartDate = startSelectedDate;
  const reportEndDate = endSelectedDate;
  const reportCurrency = currency;
  const reportUnbilledAmount = totalUnbilledAmount;
  const reportLastInvoiceDate = lastSentInvoiceDate;
  const reportOpe = ope;
  const reportCommonNames = commonNames;

  //Download TS
  const generateTimeSpent = async (forEmail = false, reportType = "timespent", reportContext = null) => {
    // Explicit report inputs let the master PDF append sections without changing page filters.
    const matter = reportContext?.matter._id ?? reportMatterId;
    const selectedMatterName = reportContext?.matter.name ?? reportMatterName;
    const client = reportContext ? reportContext.matter.client?.name || "" : reportClient;
    const selectedLawyer = reportContext ? "" : selectedLawyerForReport;
    const startSelectedDate = reportContext?.startDate ?? reportStartDate;
    const endSelectedDate = reportContext?.endDate ?? reportEndDate;
    const formattedStartDate = formatLetterDate(startSelectedDate);
    const formattedEndDate = formatLetterDate(endSelectedDate);
    const currency = reportContext ? `${reportContext.matter.currency || ""} ` : reportCurrency;
    let totalUnbilledAmount = reportUnbilledAmount;
    let lastSentInvoiceDate = reportLastInvoiceDate;
    let ope = reportOpe;
    let advanceAmount = 0;
    let commonNames = reportCommonNames;
    try {
      const isWriteOffReport = reportType === "writeoff";
      // Fetch all workhours for the selected filters
      const { data } = await axiosInstance.get(
        `/workHour/filterWorkHourByUserId`,
        {
          params: {
            user: selectedLawyer,
            fromDate: startSelectedDate,
            toDate: endSelectedDate,
            matterId: matter,
            adminId,
            excludeBinned: true,
            limit: 0, // Fetch all data without pagination
            page: 0,
          },
        }
      );

      const writeOffResponse = await axiosInstance.get(
        `/writeoffs/getWriteoffHoursByAdmin`,
        {
          params: {
            adminId,
            user: selectedLawyer,
            fromDate: startSelectedDate,
            toDate: endSelectedDate,
            matterId: matter,
            limit: 0,
            page: 0,
          },
        }
      );
      const reportWriteOffHours = writeOffResponse.data?.workHours || [];

      // console.log("selected matter", matter, matterCurr);

      advanceAmount = await findTotalAdvanceAmount(matter);
      if (reportContext) {
        totalUnbilledAmount = data.unbilledAmount || 0;
        lastSentInvoiceDate = data.lastInvoiceDate || "";
        commonNames = [...new Set([
          ...data.workHours.map((entry) => entry.user?.fullName),
          ...((showDiscount || isWriteOffReport) ? reportWriteOffHours.map((entry) => entry.user?.fullName) : []),
        ].filter(Boolean))].sort();
        const expenseResponse = await axiosInstance.get("/expense/web/admin", {
          params: { adminId, matterId: matter, fromDate: startSelectedDate,
            toDate: endSelectedDate, billableOnly: true, limit: 0, page: 0 },
        });
        const nativeCurrency = allCurrencyData.nativeCurrencyCode || "INR";
        const targetCurrency = reportContext.matter.currency || nativeCurrency;
        const rate = (code) => code.toUpperCase() === nativeCurrency.toUpperCase() ? 1 :
          Number(allCurrencyData.conversionRates?.find((item) =>
            item.currencyCode?.toUpperCase() === code.toUpperCase())?.rate);
        ope = (expenseResponse.data.expenses || []).reduce((total, expense) => {
          const sourceRate = rate(expense.currency || nativeCurrency);
          const targetRate = rate(targetCurrency);
          if (!Number.isFinite(sourceRate) || sourceRate <= 0 || !Number.isFinite(targetRate) || targetRate <= 0) {
            throw new Error("Missing currency conversion rate for matter expenses.");
          }
          return total + Number(expense.amount?.$numberDecimal || expense.amount || 0) * sourceRate / targetRate;
        }, 0);
      }
      // console.log("total amount getting", advanceAmount);

      if (
        (!data || data.workHours.length === 0) &&
        (!isWriteOffReport || reportWriteOffHours.length === 0)
      ) {
        if (reportContext) return false;
        errorAlert("No data available to generate the report.");
        return;
      }

      // Prepare table data
      const doubleUsedTableColumns = [
        "Associate Name",
        "Total Time",
        "Billed Time",
        "Hourly Rate",
        "Total Amount",
      ];

      const doubleUsedTableData = [];
      let teamTotalHours = 0;
      let teamTotalBilledHours = 0;
      let teamTotalBilledAmount = 0;
      let teamTotalDiscountAmount = 0;
      let persontotalHours = 0;
      let personTotalWriteoffHours = 0;

      // Populate the table rows
      commonNames.forEach((name) => {
        let personWorkHours = 0;
        let personWriteoffHours = 0;
        const includeWriteoffHours = showDiscount || isWriteOffReport;

        const filteredData = data.workHours.filter(
          (result) => result?.user?.fullName === name
        );

        const filterWriteoffData = reportWriteOffHours.filter(
          (entry) => entry?.user?.fullName === name
        );

        filteredData.forEach((result) => {
          personWorkHours += parseFloat(result.workHour || 0);
        });

        filterWriteoffData.forEach((result) => {
          personWriteoffHours += parseFloat(result.discountedHours || 0);
        });

        persontotalHours = parseFloat(personWorkHours);
        personTotalWriteoffHours = parseFloat(personWriteoffHours);

        // console.log(
        //   name,
        //   "personWriteoffHours",
        //   personWriteoffHours,
        //   "personTotalWriteoffHours",
        //   personTotalWriteoffHours
        // );

        const newMatter = reportContext?.matter || matters.find((item) => item._id === matter);

        let price = 0;
        if (newMatter) {
          if (newMatter.pricePerHour) {
            price = newMatter.pricePerHour.$numberDecimal;
          } else if (newMatter.resourceSpecificPrice.length !== 0) {
            const employeeEntry = newMatter.resourceSpecificPrice.find(
              (entry) => entry.includes(name)
            );

            if (employeeEntry) {
              const [, hours] = employeeEntry.split(":");
              price = hours.trim();
            }
          }
        }

        if (price) {
          const personTotalHours =
            persontotalHours +
            (includeWriteoffHours ? personTotalWriteoffHours : 0);
          let personTotalBilledAmount = price * personWorkHours;
          let personTotalDiscountAmount = includeWriteoffHours
            ? price * personWriteoffHours
            : 0;

          if (personTotalHours > 0) {
            const rowData = [
              name,
              parseFloat(personTotalHours).toFixed(2),
              persontotalHours.toFixed(2),
              currency + price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
              currency +
                personTotalBilledAmount
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            ];
            doubleUsedTableData.push(rowData);
            teamTotalHours += personTotalHours;
            teamTotalBilledHours += persontotalHours;
          }
          teamTotalBilledAmount += personTotalBilledAmount;
          teamTotalDiscountAmount += personTotalDiscountAmount;
        }
      });

      // console.log("teamTotalBilledAmount", teamTotalBilledAmount);
      // console.log("teamTotalDiscountAmount", teamTotalDiscountAmount);

      // Add footer row
      const footerRow = [
        {
          content: "Total Hours",
          styles: {
            fillColor: [97, 68, 58],
            textColor: [255, 255, 255],
            fontStyle: "bold",
          },
        },
        {
          content: teamTotalHours.toFixed(2),
          styles: {
            fillColor: [97, 68, 58],
            textColor: [255, 255, 255],
            fontStyle: "bold",
          },
        },
        {
          content: teamTotalBilledHours.toFixed(2),
          styles: {
            fillColor: [97, 68, 58],
            textColor: [255, 255, 255],
            fontStyle: "bold",
          },
        },
        {
          content: "",
          styles: {
            fillColor: [97, 68, 58],
            textColor: [255, 255, 255],
            fontStyle: "bold",
          },
        },
        {
          content:
            currency +
            teamTotalBilledAmount
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          styles: {
            fillColor: [97, 68, 58],
            textColor: [255, 255, 255],
            fontStyle: "bold",
          },
        },
      ];

      doubleUsedTableData.push(footerRow);

      // Generate the PDF
      const doc = reportContext?.doc || new jsPDF();
      if (reportContext?.hasSections) doc.addPage();
      doc.setFont("helvetica", "normal");
      doc.setTextColor(0, 0, 0);

      const pageWidth = doc.internal.pageSize.getWidth();
      const rightMargin = 15;
      const logoDesiredHeight = 20;
      const logoYPosition = 10;
      const logoXPosition = 13;

      function addHeader() {
        // Set the font style, size, and position of the header text
        const fontSize = 8;

        doc.setFont("helvetica", "normal");
        doc.setFontSize(fontSize);

        // Add the image to the header
        // doc.addImage(companyData.companyLogo, "PNG", 15, 10, 70, 9);
        doc.addImage(
          companyData.companyLogo,
          "PNG",
          logoXPosition,
          logoYPosition,
          0,
          logoDesiredHeight
        );

        // right header
        doc.setTextColor(46, 115, 176);

        const link2Width = doc.getTextWidth(link2Text);
        const link2X = pageWidth - link2Width - rightMargin;
        doc.textWithLink(link2Text, link2X, 19, {
          url: link2URL,
          underline: true,
        });

        // Set link color to blue and add underline
        const link1Width = doc.getTextWidth(link1Text);
        const link1X = pageWidth - link1Width - rightMargin;
        doc.textWithLink(link1Text, link1X, 22, {
          url: link1URL,
          underline: true,
        });

        doc.setTextColor(0);

        // Calculate text width and position to align it right
        const addressWidth = doc.getTextWidth(companyData.companyAddress);
        const addressX = pageWidth - addressWidth - rightMargin;
        doc.text(companyData.companyAddress, addressX, 26);

        // Reset text color to black
      }

      const drawCenteredWrappedText = (text, centerX, startY, maxWidth, lineHeight) => {
        const lines = doc.splitTextToSize(text || "", maxWidth);
        lines.forEach((line, index) => {
          doc.text(line, centerX, startY + index * lineHeight, {
            align: "center",
          });
        });
        return startY + Math.max(lines.length - 1, 0) * lineHeight;
      };

      const drawLeftWrappedText = (text, x, startY, maxWidth, lineHeight) => {
        const lines = doc.splitTextToSize(text || "", maxWidth);
        doc.text(lines, x, startY);
        return startY + Math.max(lines.length - 1, 0) * lineHeight;
      };

      const Timespent = "/assets/Timespent.jpg";

      doc.addImage(Timespent, "JPEG", 0, 0, 210, 297);
      doc.addImage(
        companyData.companyLogo,
        "PNG",
        logoXPosition,
        logoYPosition,
        0,
        logoDesiredHeight
      );

      const fontSize = 20;
      doc.setFontSize(fontSize);

      const dateRangeLength =
        (210 -
          doc.getTextWidth(`${formattedStartDate} - ${formattedEndDate}`)) /
        2;

      //client name
      doc.setFont("helvetica", "bold");
      doc.setTextColor(136, 106, 71);
      doc.setFontSize(20);
      const clientEndY = drawCenteredWrappedText(client, 105, 110, 180, 9);

      //matter name
      doc.setFontSize(20);
      doc.setFont("helvetica", "normal");
      const matterEndY = drawCenteredWrappedText(
        selectedMatterName,
        105,
        clientEndY + 10,
        190,
        9
      );

      //horizontal line
      const titleLineY = Math.max(145, matterEndY + 10);
      doc.setLineWidth(0.3);
      doc.setDrawColor(136, 106, 71);
      doc.line(40, titleLineY, 180, titleLineY);

      //date range
      doc.setFont("helvetica", "italic");
      doc.setTextColor(0, 0, 0); // Black color
      doc.setFontSize(15);
      doc.text(
        `${formattedStartDate} - ${formattedEndDate}`,
        dateRangeLength + 10,
        titleLineY + 15
      );

      // ----------------2nd Page --------------------

      doc.addPage();
      addHeader();
      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");

      doc.text("Dear Sir / Ma'am", 15, 40);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(136, 106, 71);
      const reportHeading = `${client} - ${selectedMatterName} For The Period ${formatMonthDate(
          startSelectedDate
        )} To ${formatMonthDate(endSelectedDate)}`;
      const reportHeadingEndY = drawLeftWrappedText(
        reportHeading,
        14,
        50,
        pageWidth - 28,
        5
      );
      doc.setTextColor(0, 0, 0);
      doc.setFont("helvetica", "normal");
      const introY = reportHeadingEndY + 10;
      doc.text(
        isWriteOffReport
          ? "Please find enclosed our memorandum of time-spent on the given matter for the said period."
          : "Please find enclosed our memorandum of time-spent on the given matter for the said period.",
        15,
        introY
      );

      // ----------------------------------Main Table declaration ------------------------

      const startY = introY + 10; // Starting Y-coordinate for the table

      doc.autoTable(doubleUsedTableColumns, doubleUsedTableData, {
        startY,
        theme: "grid",
        tableLineColor: [0, 0, 0],
        tableLineWidth: 0.1,

        didParseCell: function (data) {
          if (data.row.index === 0 && data.row.section === "head") {
            // Header row styles
            data.cell.styles.fillColor = [136, 106, 71];
            data.cell.styles.textColor = [255, 255, 255];
            data.cell.styles.halign = "left"; // Align header text to the left
            data.cell.styles.fontStyle = "bold";
            data.cell.styles.fontSize = 9;
          } else if (data.row.section === "body") {
            // Body row styles
            if (data.column.index !== 0) {
              // Right-align all columns except the first column
              data.cell.styles.halign = "right";
            }
          } else if (data.row.index === doubleUsedTableData.length - 1) {
            // Footer row align
            data.cell.styles.halign = "right"; // Align footer text to the right
            data.cell.styles.fillColor = [226, 213, 203];
            data.cell.styles.textColor = [255, 255, 255];
            data.cell.styles.fontStyle = "bold";
          } else if (
            data.row.index === doubleUsedTableData.length - 1 &&
            data.row.section === "foot"
          ) {
            // Footer row styles
            data.cell.styles.fillColor = [226, 213, 203];
            data.cell.styles.textColor = [255, 255, 255];
          }

          // Set padding for table data cells
          if (
            data.row.section === "body" &&
            data.column.index === 0 &&
            data.row.index !== -1 &&
            data.row.index !== doubleUsedTableData.length - 1
          ) {
            data.cell.styles.fontSize = 9;
            data.cell.styles.fontStyle = "arial";
            data.cell.styles.textColor = [0, 0, 0];
          }
          if (
            data.row.section === "body" &&
            data.column.index === 1 &&
            data.row.index !== -1 &&
            data.row.index !== doubleUsedTableData.length - 1
          ) {
            data.cell.styles.fontSize = 9;
            data.cell.styles.fontStyle = "arial";
            data.cell.styles.textColor = [0, 0, 0];
          }
          if (
            data.row.section === "body" &&
            data.column.index === 2 &&
            data.row.index !== -1 &&
            data.row.index !== doubleUsedTableData.length - 1
          ) {
            data.cell.styles.fontSize = 9;
            data.cell.styles.fontStyle = "arial";
            data.cell.styles.textColor = [0, 0, 0];
          }
          if (
            data.row.section === "body" &&
            data.column.index === 3 &&
            data.row.index !== -1 &&
            data.row.index !== doubleUsedTableData.length - 1
          ) {
            data.cell.styles.fontSize = 9;
            data.cell.styles.fontStyle = "arial";
            data.cell.styles.textColor = [0, 0, 0];
          }
          if (
            data.row.section === "body" &&
            data.column.index === 4 &&
            data.row.index !== -1 &&
            data.row.index !== doubleUsedTableData.length - 1
          ) {
            data.cell.styles.fontSize = 9;
            data.cell.styles.fontStyle = "arial";
            data.cell.styles.textColor = [0, 0, 0];
          }
        },
      });

      // Calculate the table height
      const tableHeight = doc.autoTable.previous.finalY - startY;

      doc.text(
        "Summary of payable on this matter is provided below ",
        15,
        startY + tableHeight + 10
      );

      doc.setFont("helvetica", "bold");
      doc.setTextColor(136, 106, 71);

      // Show the components of the payable total before adding expenses.
      const formatSummaryAmount = (amount) =>
        currency + Number(amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      const drawSummaryComponent = (label, amount, y) => {
        const amountText = formatSummaryAmount(amount);
        doc.text(label, 15, y);
        doc.text(
          amountText,
          doc.internal.pageSize.getWidth() - doc.getTextWidth(amountText) - 15,
          y
        );
      };
      drawSummaryComponent(
        "Time-spent accrued",
        teamTotalBilledAmount,
        startY + tableHeight + 20
      );
      drawSummaryComponent(
        "Add: Out of pocket expenses and other costs, if any",
        ope,
        startY + tableHeight + 28
      );
      const summaryBaseY = startY + tableHeight + 16;

      //total amount line
      doc.text(
        "Total Amount for the above period",
        15,
        summaryBaseY + 20
      );
      doc.text(
        currency +
          (parseFloat(ope) + parseFloat(teamTotalBilledAmount))
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        doc.internal.pageSize.getWidth() -
          doc.getTextWidth(
            currency +
              (parseFloat(ope) + parseFloat(teamTotalBilledAmount))
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          ) -
          15,
        summaryBaseY + 20
      );

      //discount line
      if (showDiscount) {
        doc.text(
          "Total discount for the above period",
          15,
          summaryBaseY + 28
        );
        doc.text(
          currency +
            parseFloat(teamTotalDiscountAmount)
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          doc.internal.pageSize.getWidth() -
            doc.getTextWidth(
              currency +
                (parseFloat(ope) + parseFloat(teamTotalDiscountAmount))
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            ) -
            15,
          summaryBaseY + 28
        );
      }

      // total timespent till date line // Unbilled amount since last invoice date
      doc.text(
        advanceAmount > 0
          ? "Total timespent till date"
          : `Unbilled amount since last invoice (${
              lastSentInvoiceDate !== undefined
                ? formatLetterDate(lastSentInvoiceDate)
                : "no invoices sent yet"
            })`,
        15,
        summaryBaseY + (showDiscount ? 36 : 28)
      );
      doc.text(
        currency +
          (parseFloat(ope) + parseFloat(totalUnbilledAmount))
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        doc.internal.pageSize.getWidth() -
          doc.getTextWidth(
            currency +
              (parseFloat(ope) + parseFloat(totalUnbilledAmount))
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          ) -
          15,
        summaryBaseY + (showDiscount ? 36 : 28)
      );

      //advance amount & unutilized amount
      if (advanceAmount > 0) {
        //Advance Recieved
        doc.text(
          "Advance received",
          15,
          summaryBaseY + (showDiscount ? 44 : 36)
        );
        doc.text(
          currency +
            parseFloat(advanceAmount)
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          doc.internal.pageSize.getWidth() -
            doc.getTextWidth(
              currency +
                parseFloat(advanceAmount)
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            ) -
            15,
          summaryBaseY + (showDiscount ? 44 : 36)
        );

        //Amount Payable
        if (advanceAmount < totalUnbilledAmount) {
          doc.text(
            "Amount payable",
            15,
            summaryBaseY + (showDiscount ? 52 : 44)
          );
          doc.text(
            currency +
              parseFloat(totalUnbilledAmount - advanceAmount)
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            doc.internal.pageSize.getWidth() -
              doc.getTextWidth(
                currency +
                  parseFloat(totalUnbilledAmount - advanceAmount)
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              ) -
              15,
            summaryBaseY + (showDiscount ? 52 : 44)
          );
        }

        //amount calcs for Unutilized amount
        let amountText;
        if (advanceAmount > totalUnbilledAmount) {
          // If the condition is true, calculate the amount
          amountText =
            currency +
            parseFloat(advanceAmount - totalUnbilledAmount)
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        } else {
          // If the condition is false, set "NIL" directly
          amountText = "NIL";
        }

        let y1Position = 44;

        if (showDiscount) {
          y1Position += 8;
        }

        //Unutilized amount
        doc.text(
          "Unutilized amount",
          15,
          summaryBaseY +
            (advanceAmount < totalUnbilledAmount ? y1Position + 8 : y1Position)
        );
        doc.text(
          amountText,
          doc.internal.pageSize.getWidth() - doc.getTextWidth(amountText) - 15,
          summaryBaseY +
            (advanceAmount < totalUnbilledAmount ? y1Position + 8 : y1Position)
        );
      }

      doc.setTextColor(0, 0, 0);
      doc.setFont("helvetica", "normal");

      let yPosition = advanceAmount < totalUnbilledAmount ? 56 : 64;

      if (+advanceAmount === 0) {
        yPosition = showDiscount ? 46 : 38;
      }

      if (+advanceAmount !== 0) {
        yPosition = showDiscount ? 62 : 54;
        if (advanceAmount < totalUnbilledAmount) {
          yPosition += 8;
        }
      }

      doc.text(
        "Please do let us know if any changes are required. Please note that this is only a statement of timespent for ",
        15,
        summaryBaseY + yPosition
      );
      doc.text(
        "your reference and not an invoice. The invoice shall be raised subsequently in the manner agreed with you.",
        15,
        summaryBaseY + yPosition + 5
      );

      doc.text("Yours Sincerely,", 15, summaryBaseY + yPosition + 13);

      doc.setFont("helvetica", "bold");
      doc.text(auth.user.fullName, 15, summaryBaseY + yPosition + 18);
      doc.setFont("helvetica", "normal");

      // --------------------------------------3rd Page----------------------------------------------------
      doc.addPage();
      addHeader();

      let startY1 = 35; // Starting y-coordinate for each table

      commonNames.forEach((name, index) => {
        let uniqueWorkHours = [];

        if (isWriteOffReport) {
          const entriesById = new Map();
          data.workHours
            .filter((entry) => entry.user?.fullName === name)
            .forEach((entry) => {
              entriesById.set(entry._id || entry.workDescription, entry);
            });
          reportWriteOffHours
            .filter((entry) => entry.user?.fullName === name)
            .forEach((entry) => {
              entriesById.set(entry._id || entry.workDescription, entry);
            });
          uniqueWorkHours = Array.from(entriesById.values());
        } else if (showDiscount) {
          // Combine the workHours and writeOffHours arrays
          const combinedWorkHours = data.workHours.concat(reportWriteOffHours);

          // Filter entries for the current user first
          const userWorkHours = combinedWorkHours.filter(
            (entry) => entry.user?.fullName === name
          );

          // Initialize a new Set for each user to track seen descriptions
          const seenDescriptions = new Set();

          userWorkHours.forEach((entry) => {
            if (!seenDescriptions.has(entry.workDescription)) {
              uniqueWorkHours.push(entry);
              seenDescriptions.add(entry.workDescription);
            }
          });
        } else {
          // If not showing discount, filter workHours for the current user
          uniqueWorkHours = data.workHours.filter(
            (entry) => entry.user?.fullName === name
          );
        }

        const personData = uniqueWorkHours
          .filter(
            (result) =>
              result.user?.fullName === name &&
              result.workDate >= startSelectedDate
          )
          .sort((a, b) => new Date(a.workDate) - new Date(b.workDate)); // Sort the data by workDate in ascending order

        const billedTime = personData.reduce(
          (total, result) => total + parseFloat(result.workHour || 0),
          0
        );

        const discountedTime = personData.reduce(
          (total, result) => total + parseFloat(result.discountedHours || 0),
          0
        );

        const headerRow = [
          {
            content: name,
            colSpan: 2,
            styles: {
              cellWidth: "auto", // Set cell width to auto to allow content alignment
              halign: "left",
              fillColor: [136, 106, 71],
              textColor: [255, 255, 255],
              fontStyle: "bold", // Set the font style to bold
            },
          },
          {
            content: "Total Time",
            styles: {
              cellWidth: "auto", // Set cell width to auto to allow content alignment
              halign: "left",
              fillColor: [136, 106, 71],
              textColor: [255, 255, 255],
              fontStyle: "bold", // Set the font style to bold
            },
          },
          {
            content: "Billed Time",
            styles: {
              cellWidth: "auto", // Set cell width to auto to allow content alignment
              halign: "left",
              fillColor: [136, 106, 71],
              textColor: [255, 255, 255],
              fontStyle: "bold", // Set the font style to bold
            },
          },
          showDiscount &&
            !isWriteOffReport && {
            content: "Unbilled Time",
            styles: {
              cellWidth: "auto", // Set cell width to auto to allow content alignment
              halign: "left",
              fillColor: [136, 106, 71],
              textColor: [255, 255, 255],
              fontStyle: "bold", // Set the font style to bold
            },
          },
        ].filter(Boolean);

        const tableRows = [headerRow]; // Initialize tableRows with the header row
        let commentsText = " ";

        // Add individual data rows for the person
        if (personData.length > 0) {
          personData.forEach((result) => {
            commentsText = result.comments || " ";

            const totalHours =
              parseFloat(result.workHour || 0) +
              (showDiscount || isWriteOffReport
                ? parseFloat(result.discountedHours || 0)
                : 0);

            const data = [
              formatMonthDate(result.workDate),
              showComment === true && commentsText !== " "
                ? `${result.workDescription}

--------------------------------------------------------------------------------------
||      ${commentsText}  ||`
                : result.workDescription,
              parseFloat(totalHours).toFixed(2),
              parseFloat(result.workHour || 0).toFixed(2),
              showDiscount && !isWriteOffReport
                ? parseFloat(result.discountedHours || 0).toFixed(2)
                : null,
            ].filter((cell) => cell !== null);

            tableRows.push(data);
          });

          const totalTime = parseFloat(
            billedTime + (showDiscount || isWriteOffReport ? discountedTime : 0)
          );

          // Add footer row with total time
          const footerRow = [
            {
              content: "Total Time",
              colSpan: 2,
              styles: {
                halign: "left",
                fillColor: [97, 68, 58],
                textColor: [255, 255, 255],
                fontStyle: "bold",
              },
            },
            {
              content: totalTime.toFixed(2),
              styles: {
                halign: "right",
                fillColor: [97, 68, 58],
                textColor: [255, 255, 255],
                fontStyle: "bold",
              },
            },
            {
              content: billedTime.toFixed(2),
              styles: {
                halign: "right",
                fillColor: [97, 68, 58],
                textColor: [255, 255, 255],
                fontStyle: "bold",
              },
            },
            showDiscount &&
              !isWriteOffReport && {
              content: discountedTime.toFixed(2),
              styles: {
                halign: "right",
                fillColor: [97, 68, 58],
                textColor: [255, 255, 255],
                fontStyle: "bold",
              },
            },
          ].filter(Boolean);
          tableRows.push(footerRow);

          // Remove empty rows and columns from tableRows
          const filteredTableRows = tableRows.map((row) => row.filter(Boolean));

          // Generate table for the current person
          doc.autoTable({
            body: filteredTableRows, // Your data rows
            startY: startY1, // Starting Y position for the table
            theme: "grid", // Grid theme for the table
            tableLineColor: [0, 0, 0], // Black table borders
            tableLineWidth: 0.1, // Table border width
            didParseCell: function (data) {
              if (data.row.section === "body") {
                const currentRowData = data.row.raw; // Raw data for the current row
                const discountedHoursIndex = 4; // Adjust this index to match the "Discount Time" column in your table structure
                const discountedHours =
                  parseFloat(currentRowData[discountedHoursIndex]) || 0;

                // Apply italic style only to the "Work Description" column
                if (data.column.index === 1 && discountedHours > 0) {
                  // Column index 1 corresponds to "Work Description"
                  data.cell.styles.fontStyle = "italic";
                }

                // Apply general styles for "Work Description" column
                if (data.column.index === 1) {
                  data.cell.styles.cellPadding = {
                    top: 3,
                    right: 4,
                    bottom: 3,
                    left: 4,
                  };
                  data.cell.styles.halign = "left"; // Align left
                  data.cell.styles.textColor = [0, 0, 0]; // Black text color
                }
              }

              // Header row styling
              if (data.row.section === "head") {
                data.cell.styles.fillColor = [136, 106, 71]; // Header background color
                data.cell.styles.textColor = [255, 255, 255]; // Header text color
                data.cell.styles.halign = "left"; // Align header text left
                data.cell.styles.fontStyle = "bold"; // Bold font style for header
                data.cell.styles.fontSize = 9; // Header font size
              }

              // Footer row styling
              if (
                data.row.index === filteredTableRows.length - 1 &&
                data.row.section === "body"
              ) {
                data.cell.styles.fillColor = [97, 68, 58]; // Footer background color
                data.cell.styles.textColor = [255, 255, 255]; // Footer text color
                data.cell.styles.fontStyle = "bold"; // Bold font style for footer
              }

              // Highlight rows with comments
              if (data.row.section === "body" && data.column.index === 1) {
                const cellText = data.cell.text || ""; // Get cell text
                if (
                  cellText.includes(
                    "-----------------------------------------------------------------------------------------------------------"
                  )
                ) {
                  data.cell.styles.fillColor = [215, 230, 230]; // Highlight rows with comments
                }
              }

              // General column-specific styles
              if (
                data.row.section === "body" &&
                data.column.index >= 0 &&
                data.row.index !== 0 &&
                data.row.index !== filteredTableRows.length - 1
              ) {
                data.cell.styles.fontSize = 9;
                data.cell.styles.textColor = [0, 0, 0];
              }

              //column styles
              if (
                data.row.section === "body" &&
                data.column.index === 0 &&
                data.row.index !== 0 &&
                data.row.index !== tableRows.length - 1
              ) {
                data.cell.styles.cellPadding = {
                  top: 3,
                  right: 2,
                  bottom: 3,
                  left: 2,
                };
                data.cell.styles.halign = "left";
                data.cell.styles.fontSize = 9;
                data.cell.styles.cellWidth = 20;
                data.cell.styles.textColor = [0, 0, 0];
              }

              if (
                data.row.section === "body" &&
                data.column.index === 2 &&
                data.row.index !== 0 &&
                data.row.index !== tableRows.length - 1
              ) {
                data.cell.styles.cellPadding = {
                  top: 3,
                  right: 2,
                  bottom: 3,
                  left: 2,
                };
                data.cell.styles.halign = "right";
                data.cell.styles.fontSize = 9;
                data.cell.styles.cellWidth = 20;
                data.cell.styles.textColor = [0, 0, 0];
              }

              if (
                data.row.section === "body" &&
                data.column.index === 3 &&
                data.row.index !== 0 &&
                data.row.index !== tableRows.length - 1
              ) {
                data.cell.styles.cellPadding = {
                  top: 3,
                  right: 2,
                  bottom: 3,
                  left: 2,
                };
                data.cell.styles.halign = "right";
                data.cell.styles.fontSize = 9;
                data.cell.styles.cellWidth = 20;
                data.cell.styles.textColor = [0, 0, 0];
              }

              if (
                data.row.section === "body" &&
                data.column.index === 4 &&
                data.row.index !== 0 &&
                data.row.index !== tableRows.length - 1
              ) {
                data.cell.styles.cellPadding = {
                  top: 3,
                  right: 2,
                  bottom: 3,
                  left: 2,
                };
                data.cell.styles.halign = "right";
                data.cell.styles.fontSize = 9;
                data.cell.styles.cellWidth = 20;
                data.cell.styles.textColor = [0, 0, 0];
              }
            },
          });

          startY1 = doc.lastAutoTable.finalY + 10; // Update startY for the next table
        }
      });

      if (reportContext) return true;

      const rawName = `${client} - ${selectedMatterName} For The Period ${formatMonthDate(
        startSelectedDate
      )} To ${formatMonthDate(endSelectedDate)}.pdf`;
      const pdfFileName = rawName.trimStart();

      //generate the blob
      const pdfBlob = doc.output("blob");

      if (forEmail) {
        // only upload + return when emailing
        const pdfURL = await uploadTimespent(pdfBlob, pdfFileName);
        if (!pdfURL) throw new Error("Failed to upload for email");
        return { pdfURL, pdfFileName };
      } else {
        // **new**: upload every time we download
        const pdfURL = await uploadTimespent(pdfBlob, pdfFileName);
        if (!pdfURL) {
          errorAlert(
            "Report uploaded failed, but you can still download locally."
          );
        }
        // then download locally
        doc.save(pdfFileName);
        successAlert(
          isWriteOffReport
            ? "Write off report downloaded successfully."
            : "Timespent downloaded successfully."
        );
        return null;
      }
    } catch (error) {
      if (reportContext) throw error;
      console.error("Error generating the report:", error);
      errorAlert("Failed to generate the report. Please try again.");
    }
  };

  const downloadReviewerTimespent = async (event) => {
    event.preventDefault();
    if (reviewerReportLock.current || !selectedReviewer || !reviewerMatters.length || matterLoading || matterError) return;
    if (isReviewerLogin && selectedReviewer.value !== loggedInReviewerName) return;
    if (!startSelectedDate || !endSelectedDate || startSelectedDate > endSelectedDate) {
      errorAlert("Select a valid date range before downloading.");
      return;
    }
    reviewerReportLock.current = true;
    setReviewerReportBusy(true);
    try {
      const doc = new jsPDF();
      let included = 0;
      const startDate = startSelectedDate;
      const endDate = endSelectedDate;
      for (const [index, assignedMatter] of reviewerMatters.entries()) {
        setReviewerReportProgress(`${index + 1} of ${reviewerMatters.length}: ${assignedMatter.name}`);
        const appended = await generateTimeSpent(false, rightOffPdfEnabled ? "writeoff" : "timespent", {
          doc, matter: assignedMatter, startDate, endDate, hasSections: included > 0,
        });
        if (appended) included += 1;
      }
      if (!included) {
        errorAlert("No time entries found for this reviewer’s matters in the selected period.");
        return;
      }
      const safeName = selectedReviewer.value.replace(/[\\/:*?"<>|]/g, "-");
      doc.save(`Master Reviewer TS - ${safeName} - ${startDate} to ${endDate}.pdf`);
      successAlert(`Master reviewer Timespent downloaded: ${included} matter(s).`);
      setReviewerModalOpen(false);
    } catch (error) {
      console.error("Error generating master reviewer Timespent:", error);
      errorAlert("Could not generate the complete reviewer report. Please try again.");
    } finally {
      reviewerReportLock.current = false;
      setReviewerReportBusy(false);
      setReviewerReportProgress("");
    }
  };

  const openModal = (time, type) => {
    setShowModal(true);

    if (type === "duplicate") {
      setEditingTime(null);
      setDate(time.workDate);
      setWorkDescription(time.workDescription);
      setModalSelectedLawyerName(time.user.fullName);
      setModalSelectedLawyerId(time.user._id);
      setModalMatter(time.matter._id);
      setModalSelectedMatterName(time.matter.name);
      setComments(time.comments);
      const hour = String(time.workHour).split(".");
      setWorkHour(hour[0]);
      setWorkMin(Math.floor((hour[1] * 6) / 10));
    } else if (type === "add") {
      setEditingTime(null);
      setDate(formatDate(new Date()));
      setWorkDescription("");
      setModalSelectedLawyerId("");
      setModalSelectedLawyerName("");
      setModalMatter("");
      setModalSelectedMatterName("");
      setComments("");
      setWorkHour(0);
      setWorkMin(30);
    } else {
      setEditingTime(time);
      setDate(time.workDate);
      setEntryId(time._id);
      setWorkDescription(time.workDescription);
      setModalSelectedLawyerName(time.user.fullName);
      setModalSelectedLawyerId(time.user._id);
      // setUserId(time.user._id);
      setModalMatter(time.matter._id);
      setModalSelectedMatterName(time.matter.name);
      setComments(time.comments);
      const hour = String(time.originalWorkHour ?? time.workHour).split(".");
      setWorkHour(hour[0]);
      setWorkMin(Math.floor((hour[1] * 6) / 10));
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setDate(formatDate(new Date()));
    setWorkDescription("");
    // setUserId("");
    setModalSelectedLawyerName("");
    setModalSelectedLawyerId("");
    setModalMatter("");
    setModalSelectedMatterName("");
    setModalClient("");
    setComments("");
    setWorkHour(0);
    setWorkMin(30);
    setEntryId("");
    setAiSuggestion("");
    setIsRetryingAi(false);
  };

  //Form Validation
  const isValidObjField = () => {
    if (
      date === "" ||
      modalSelectedLawyerId === "" ||
      modalMatter === "" ||
      workDescription === "" ||
      workHour === "00" ||
      workMin === "00"
    ) {
      return false;
    } else {
      return true;
    }
    // return Object.values(obj).every(value => value.trim())
  };

  const isValidForm = () => {
    //all fields must be filled
    if (!isValidObjField()) return errorAlert("All Fields are Required!");

    return true;
  };

  //Add, Duplicate and Edit Time
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (descRef.current) {
      setWorkDescription(descRef.current.value);
    }

    const time = {
      admin: getPortalCompanyId(auth.user),
      user: modalSelectedLawyerId,
      workDate: date,
      matter: modalMatter,
      workDescription,
      comments,
      workHour: `${workHour}.${workMin * (10 / 6)}`,
      reviewed: "true",
    };

    if (isValidForm()) {
      if (editingTime) {
        const response = await axiosInstance.put(
          `/workHour/update/${entryId}`,
          time
        );

        if (response.data) {
          successAlert("Time Updated Successfully!");
          setFilteredWorkHour((prevFilteredWorkHour) => {
            const updatedWorkHour = prevFilteredWorkHour.map((entry) =>
              entry._id === entryId ? response.data : entry
            );
            return updatedWorkHour;
          });
          closeModal();
          filterBetweenDates();
        }
      } else {
        try {
          const response = await axiosInstance.post(
            `/workHour/createNew`,
            time
          );

          if (response.data) {
            successAlert("Great!! Time Added Successfully.");

            // Call filterBetweenDates after adding time
            setFilteredWorkHour((prevFilteredWorkHour) => {
              // Include the new entry in the updated state
              const updatedWorkHour = [...prevFilteredWorkHour, response.data];
              return updatedWorkHour;
            });
            filterBetweenDates();
            closeModal();
          }
        } catch (error) {
          console.error("Error adding time:", error);
          errorAlert("Error adding time");
        }
      }
    }
  };

  //address comment function
  const markCommentAsAddressed = (entryId) => {
    setAddressedComments((prev) => ({
      ...prev,
      [entryId]: !prev[entryId], // Toggle the addressed state
    }));
  };

  //mupltiple select entries functions
  const handleSelectEntry = (id, checked) => {
    if (checked) {
      setSelectedEntries([...selectedEntries, id]);
    } else {
      setSelectedEntries(selectedEntries.filter((entryId) => entryId !== id));
    }
  };

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setSelectAll(isChecked);

    // If "Select All" checkbox is checked, set all entry IDs as selected; otherwise, clear selection
    setSelectedEntries(
      isChecked
        ? filteredWorkHour
            .filter((entry) => entry.workDate >= startSelectedDate)
            .map((entry) => entry._id)
        : []
    );
  };

  const handleUpdateEntries = () => {
    // Send Axios request to backend to update selected entries with new matter code

    if (newMatter) {
      handleUpdateEntriesAlert();
    } else {
      errorAlert("Select the new matter");
    }
  };

  const handleUpdateEntriesAlert = (id) => {
    toast(
      <ConfirmationAlert
        onDeleteOff={() => onUpdateMultipleEntries(id)}
        question={"Are you sure to update matter of all selected entries?"}
        answer={"Yes, Update Matter"}
        icon={<Update />}
      />,
      {
        position: toast.POSITION.TOP_CENTER,
        closeButton: true,
        autoClose: false,
        draggable: false,
      }
    );
  };

  const onUpdateMultipleEntries = async (entryId) => {
    axiosInstance
      .post("/updateMatterCodeEntries", {
        entries: selectedEntries,
        newMatter,
      })
      .then((response) => {
        // Handle success response
        filterBetweenDates();
      })
      .catch((error) => {
        // Handle error
        console.error("Error updating entries:", error);
      });
  };

  const handleWriteoffSingle = async (entryId) => {
    try {
      const response = await axiosInstance.delete(
        `/workhour/admin/delete/${entryId}`
      );

      if (response.data) {
        successAlert("Entry written off successfully");

        // console.log("data", response.data);

        // Store the single write-off entry for undo
        setWriteoffItem(response.data?.updatedWorkHour?._id);
        setSingleWriteoffSnackbarOpen(true);

        // Remove the entry from the UI after write-off
        setFilteredWorkHour((prev) =>
          prev.filter((entry) => entry._id !== entryId)
        );
      } else {
        errorAlert("Failed to write off entry.");
      }
    } catch (error) {
      errorAlert("An error occurred while writing off the entry.");
    }
  };

  const handleUndoWriteoffSingle = async () => {
    try {
      if (writeoffItem) {
        const response = await axiosInstance.post(
          `/workhour/restorefromwriteoff/${writeoffItem}`
        );

        if (response.data) {
          successAlert("Entry write-off undone successfully");

          // Restore the entry in the UI
          setFilteredWorkHour((prev) => [...prev, writeoffItem]);
          setWriteoffItem(null);
          setSingleWriteoffSnackbarOpen(false);
          filterBetweenDates();
        } else {
          errorAlert("Failed to restore the write-off.");
        }
      }
    } catch (error) {
      errorAlert("An error occurred while undoing the write-off.");
    }
  };

  const handleWriteoffMultiple = async () => {
    if (selectedEntries.length === 0) {
      errorAlert("No entries selected for write-off");
      return;
    }

    try {
      // Send delete requests for each selected entry
      const writeOffPromises = selectedEntries.map((entryId) =>
        axiosInstance.delete(`/workhour/admin/delete/${entryId}`)
      );

      // Await the responses for all requests
      const responses = await Promise.all(writeOffPromises);

      successAlert("Selected entries written off");

      // Extract the created write-off entries from the responses
      const writeOffData = responses.map(
        (response) => response.data?.updatedWorkHour
      );

      // Store the write-off entries for undo
      setWriteoffEntries(writeOffData);

      // Remove the written-off entries from the UI
      setFilteredWorkHour((prev) =>
        prev.filter((entry) => !selectedEntries.includes(entry._id))
      );

      setMultipleWriteoffSnackbarOpen(true);

      // Clear selected entries
      setSelectedEntries([]);
      setSelectAll(false);
    } catch (error) {
      errorAlert("Failed to write off selected entries.");
      console.error("Error during multiple write-off:", error);
    }
  };

  const handleUndoWriteoffMultiple = async () => {
    try {
      const restorePromises = writeoffEntries.map((entry) =>
        axiosInstance.post(`/workhour/restorefromwriteoff/${entry._id}`)
      );

      // Wait for all restore operations to complete
      await Promise.all(restorePromises);

      successAlert("Selected write-offs undone successfully");

      // Restore the write-off entries in the UI
      setFilteredWorkHour((prev) => [...prev, ...writeoffEntries]);

      // Clear write-off entries
      setWriteoffEntries([]);
      setMultipleWriteoffSnackbarOpen(false);
      filterBetweenDates();
    } catch (error) {
      errorAlert("Failed to undo write-off for selected entries.");
      console.error("Error during undoing multiple write-offs:", error);
    }
  };

  const handleSoftDeleteMultiple = () => {
    const entries = filteredWorkHour.filter((entry) => selectedEntries.includes(entry._id));
    if (!entries.length) return errorAlert("No entries selected to move to Bin");
    setBinEntries(entries);
  };

  const submitBinTime = async (options) => {
    if (binRequestLock.current || !binEntries.length) return;
    binRequestLock.current = true;
    setBinBusy(true);
    try {
      const results = await Promise.allSettled(binEntries.map((entry) =>
        axiosInstance.put(`/workhour/bin/${entry._id}`, {
          ...options, expectedAvailableHours: Number(entry.workHour),
        }).then(({ data }) => ({ ...entry, entryId: entry._id, hoursMoved: data.hoursMoved }))
      ));
      const moved = results.filter((result) => result.status === "fulfilled").map((result) => result.value);
      const failed = results.filter((result) => result.status === "rejected");
      if (moved.length) {
        if (binEntries.length === 1) {
          setDeletedItem(moved[0]);
          setSingleDeleteSnackbarOpen(true);
        } else {
          setDeletedEntries(moved);
          setMultipleDeleteSnackbarOpen(true);
        }
        setSelectedEntries([]);
        setSelectAll(false);
        setBinEntries([]);
        successAlert("Selected time moved to Bin.");
      }
      if (failed.length) {
        setBinEntries([]);
        errorAlert(failed[0].reason.response?.data?.message || "Some entries could not be moved. Refresh and try again.");
      }
      await filterBetweenDates();
    } finally {
      binRequestLock.current = false;
      setBinBusy(false);
    }
  };

  const handleUndoMultiple = async () => {
    try {
      const restorePromises = deletedEntries.map((entry) => {
        return axiosInstance.post(`/workhour/bin/restore/${entry._id}`, { hoursToRestore: entry.hoursMoved });
      });

      await Promise.all(restorePromises);

      successAlert("Selected entries restored from Bin successfully");

      // Restore entries in the UI

      setDeletedEntries([]);
      setMultipleDeleteSnackbarOpen(false);
      await filterBetweenDates();
    } catch (error) {
      errorAlert("Failed to restore selected entries.");
    }
  };

  const handleSoftDeleteSingle = (entry) => setBinEntries([entry]);

  const handleUndoSingle = async () => {
    try {
      if (deletedItem) {
        const response = await axiosInstance.post(
          `/workhour/bin/restore/${deletedItem.entryId}`, { hoursToRestore: deletedItem.hoursMoved }
        );

        if (response.data) {
          successAlert("Entry restored from Bin successfully");

          setDeletedItem(null);
          setSingleDeleteSnackbarOpen(false);
          filterBetweenDates();
        } else {
          errorAlert("Failed to restore the entry.");
        }
      }
    } catch (error) {
      errorAlert("An error occurred while restoring the entry.");
    }
  };

  const handleDiscountClick = (itemId, workHour) => {
    setSelectedItemId(itemId);
    setOpenDiscountModal(true);
    setSelectedItemWorkHours(workHour); // Set work hours of the selected item
  };

  const handleModalClose = () => {
    setOpenDiscountModal(false);
    setSelectedItemId(null);
  };

  const handleDiscountSubmit = async (itemId, discountValue) => {
    // console.log(
    //   "Submitting discount for item:",
    //   itemId,
    //   "with value:",
    //   discountValue
    // );

    // Call the API to apply the discount using the passed discountValue directly
    await onhandleApplyDiscount(itemId, discountValue);

    // Close the modal after submitting
    handleModalClose();
  };

  //main table data show function
  const renderRows = () => {
    return commonNames.map((employee) => {
      let totalWorkHours = 0;
      let totalWriteoffHoursForUser = 0;
      return (
        <React.Fragment key={employee}>
          {/* Timespent entries  */}
          {filteredWorkHour
            .filter((result) => result?.user?.fullName === employee)
            .map((item, index) => {
              totalWorkHours += parseFloat(item.workHour);
              return (
                <TableRow key={item._id} role="checkbox" tabIndex={-1}>
                  <TableCell>
                    <input
                      type="checkbox"
                      className="custom-checkbox"
                      checked={selectedEntries.includes(item._id)}
                      onChange={(e) =>
                        handleSelectEntry(item._id, e.target.checked)
                      }
                    />
                  </TableCell>
                  <TableCell>{formatMonthDate(item.workDate)}</TableCell>
                  <TableCell>{item.user?.fullName}</TableCell>
                  {/* <TableCell>{item.matter?.name}</TableCell> */}
                  <TableCell>
                    {item.workDescription}
                    {showComment && item.comments && (
                      <>
                        <p
                          style={{
                            marginTop: "10px",
                            padding: "5px",
                            backgroundColor: "yellow",
                            color: "red",
                            textDecoration: addressedComments[item._id]
                              ? "line-through"
                              : "none",
                          }}
                        >
                          {item?.comments ? item.comments : ""}
                        </p>

                        <Button
                          style={{
                            backgroundColor: "lightgrey",
                            color: "red",
                            fontSize: "12px",
                          }}
                          onClick={() => markCommentAsAddressed(item._id)}
                        >
                          Address Comment
                        </Button>
                      </>
                    )}
                  </TableCell>
                  <TableCell>{parseFloat(item.workHour).toFixed(2)}</TableCell>
                  <TableCell>
                    <CustomTooltip text="Edit Entry">
                      <CiEdit
                        size={20}
                        style={{ cursor: "pointer" }}
                        onClick={() => openModal(item, "edit")}
                      />
                    </CustomTooltip>
                  </TableCell>
                  {/* <TableCell>
                    <CustomTooltip text="Discount Entered Hours">
                      <Discount
                        size={18}
                        style={{ cursor: "pointer" }}
                        onClick={() => handleDiscount(item._id)}
                      />
                    </CustomTooltip>
                  </TableCell> */}
                  <TableCell>
                    <CustomTooltip text="Discount Entered Hours">
                      <Discount
                        size={18}
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          handleDiscountClick(item._id, item.workHour)
                        }
                      />
                    </CustomTooltip>
                  </TableCell>
                  <TableCell>
                    <CustomTooltip text="Complete WriteOff">
                      <TbDiscount2Off
                        size={18}
                        style={{ cursor: "pointer" }}
                        onClick={() => handleWriteoffSingle(item._id)}
                      />
                    </CustomTooltip>
                  </TableCell>
                  <TableCell className="table-cell">
                    <CustomTooltip text="Move to Bin">
                      <RiDeleteBin6Line
                        size={18}
                        style={{ cursor: "pointer" }}
                        onClick={() => handleSoftDeleteSingle(item)}
                      />
                    </CustomTooltip>
                  </TableCell>

                  <TableCell className="table-cell">
                    <CustomTooltip text="Duplicate Entry">
                      <BiDuplicate
                        size={18}
                        style={{ cursor: "pointer" }}
                        onClick={() => openModal(item, "duplicate")}
                      />
                    </CustomTooltip>
                  </TableCell>
                </TableRow>
              );
            })}

          {/* Timespent entries  */}
          {writeOffHours
            .filter((result) => result?.user?.fullName === employee)
            .map((item, index) => {
              totalWriteoffHoursForUser += parseFloat(item.discountedHours);
              return (
                <TableRow key={item._id} role="checkbox" tabIndex={-1}>
                  <TableCell>
                    <b>W/O</b>
                  </TableCell>
                  <TableCell>{formatMonthDate(item.workDate)}</TableCell>
                  <TableCell>{item.user?.fullName}</TableCell>
                  <TableCell>
                    <i>{item.workDescription}</i>
                  </TableCell>
                  <TableCell>
                    {parseFloat(item.discountedHours).toFixed(2)}
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </TableRow>
              );
            })}

          {totalWorkHours > 0 && (
            <React.Fragment>
              <TableRow style={{ backgroundColor: "black" }}>
                <TableCell
                  colSpan={4}
                  style={{
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "14px",
                  }}
                >
                  Total Work Hours of {employee}:
                </TableCell>
                <TableCell
                  style={{
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "14px",
                  }}
                >
                  {totalWorkHours.toFixed(2)}
                </TableCell>
                <TableCell>({totalWriteoffHoursForUser.toFixed(2)})</TableCell>
                <TableCell colSpan={6}></TableCell>
              </TableRow>
            </React.Fragment>
          )}
        </React.Fragment>
      );
    });
  };

  //Upload pdf file in digital ocean spaces
  const uploadTimespent = async (pdfBlob, pdfFileName) => {
    // console.log("upload ts");

    const formData = new FormData();
    formData.append("file", pdfBlob, pdfFileName);
    formData.append("adminId", getPortalCompanyId(auth.user));
    formData.append("matterId", matter);
    formData.append("startDate", startSelectedDate);
    formData.append("endDate", endSelectedDate);

    try {
      const response = await axiosInstance.post(`/uploadTimespent`, formData);

      const data = await response.data;
      if (!response.data) {
        throw new Error(data.message || "Failed to upload PDF");
      }
      // The uploaded file URL
      return data.url;
    } catch (error) {
      console.error("Error uploading PDF:", error);
      errorAlert("Error uploading PDF");
      return null;
    }
  };

  // Function to handle sending email
  const handleSendEmail = async () => {
    try {
      // Step 1: Generate the report

      setLoading(true);
      const { pdfURL, pdfFileName } = await generateTimeSpent(true);
      if (!pdfURL) {
        errorAlert("Failed to upload the report.");
        return;
      }

      await axiosInstance.post("/email/send-report", {
        matterId: matter,
        email,
        pdfURL,
        pdfFileName,
      });

      successAlert("Email sent successfully!");
      setEmailModalOpen(false);
      setLoading(false);
      setEmail("");
    } catch (error) {
      console.error("Error sending email:", error);
      errorAlert("Failed to send email. Please try again.");
      setLoading(false);
    }
  };

  const findTotalAdvanceAmount = async (reportMatterId = matter) => {
    // Use find() instead of filter() to get a single object
    // const selectedMatter = matters.find((matter) => matter._id === e.value);

    // console.log("selectedMatter", matter);

    const invoiceResponses = await axiosInstance.get(`/invoices`, {
      params: {
        limit: 0,
        page: 0,
        matterId: reportMatterId,
        invoiceType: "advance",
        status: "collected",
      },
    });

    // console.log("invoiceResponses", invoiceResponses.data.invoices);

    //here I have to change this to the invoices collected amount not the matter advance amount
    const totalAdvanceAmount =
      invoiceResponses.data.invoices.length > 0 &&
      invoiceResponses.data.invoices.reduce(
        (total, data) => total + parseFloat(data.amount.$numberDecimal),
        0
      );

    // setAdvanceAmount(totalAdvanceAmount || 0);

    // console.log("totalAdvanceAmount", totalAdvanceAmount || 0);
    // console.log("advanceAmount", advanceAmount);

    return totalAdvanceAmount;
  };

  // NEW: render entries grouped by date → then by lawyer
  const renderDateGroupedRows = () => {
    // 1️⃣ group by date
    const byDate = filteredWorkHour.reduce((acc, entry) => {
      acc[entry.workDate] = acc[entry.workDate] || [];
      acc[entry.workDate].push(entry);
      return acc;
    }, {});

    return Object.keys(byDate)
      .sort((a, b) => new Date(b) - new Date(a)) // newest first
      .map((dateKey) => {
        const entries = byDate[dateKey];

        // 2️⃣ within each date, group by lawyer
        const byLawyer = entries.reduce((acc, e) => {
          // const name = e.user.fullName;
          const name = e.user?.fullName || "Unknown"; //govind done this
          acc[name] = acc[name] || [];
          acc[name].push(e);
          return acc;
        }, {});

        return (
          <React.Fragment key={dateKey}>
            {/* ——— date header ——— */}
            <TableRow>
              <TableCell
                colSpan={columns.length + 1}
                style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}
              >
                {formatDateWithWeekday(dateKey)}
              </TableCell>
            </TableRow>

            {/* ——— each lawyer under that date ——— */}
            {Object.keys(byLawyer)
              .sort()
              .map((lawyer) => (
                <React.Fragment key={`${dateKey}-${lawyer}`}>
                  {/* sub-header with icon */}
                  <TableRow>
                    <TableCell
                      colSpan={columns.length + 1}
                      style={{
                        paddingLeft: 24,
                        fontWeight: 700,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <PersonIcon fontSize="small" style={{ marginRight: 8 }} />
                      {lawyer}
                    </TableCell>
                  </TableRow>

                  {/* ——— each entry row ——— */}
                  {byLawyer[lawyer].map((item) => (
                    <TableRow key={item._id} role="checkbox" tabIndex={-1}>
                      <TableCell>
                        <input
                          type="checkbox"
                          checked={selectedEntries.includes(item._id)}
                          onChange={(e) =>
                            handleSelectEntry(item._id, e.target.checked)
                          }
                        />
                      </TableCell>

                      <TableCell>{formatMonthDate(item.workDate)}</TableCell>
                      <TableCell>{item.user?.fullName || ""}</TableCell>

                      {/* description + optional comments */}
                      <TableCell>
                        {item.workDescription}
                        {showComment && item.comments && (
                          <>
                            <p
                              style={{
                                marginTop: "8px",
                                padding: "4px",
                                backgroundColor: "yellow",
                                color: "red",
                                textDecoration: addressedComments[item._id]
                                  ? "line-through"
                                  : "none",
                              }}
                            >
                              {item.comments}
                            </p>
                            <Button
                              size="small"
                              onClick={() => markCommentAsAddressed(item._id)}
                            >
                              Address Comment
                            </Button>
                          </>
                        )}
                      </TableCell>

                      <TableCell>
                        {parseFloat(item.workHour).toFixed(2)}
                      </TableCell>

                      {/* ——— action cells ——— */}
                      <TableCell>
                        <CustomTooltip text="Edit Entry">
                          <CiEdit
                            size={20}
                            style={{ cursor: "pointer" }}
                            onClick={() => openModal(item, "edit")}
                          />
                        </CustomTooltip>
                      </TableCell>

                      <TableCell>
                        <CustomTooltip text="Discount Entered Hours">
                          <Discount
                            fontSize="small"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              handleDiscountClick(item._id, item.workHour)
                            }
                          />
                        </CustomTooltip>
                      </TableCell>

                      <TableCell>
                        <CustomTooltip text="Complete WriteOff">
                          <TbDiscount2Off
                            size={18}
                            style={{ cursor: "pointer" }}
                            onClick={() => handleWriteoffSingle(item._id)}
                          />
                        </CustomTooltip>
                      </TableCell>

                      <TableCell>
                        <CustomTooltip text="Move to Bin">
                          <RiDeleteBin6Line
                            size={18}
                            style={{ cursor: "pointer" }}
                            onClick={() => handleSoftDeleteSingle(item)}
                          />
                        </CustomTooltip>
                      </TableCell>

                      <TableCell>
                        <CustomTooltip text="Duplicate Entry">
                          <BiDuplicate
                            size={18}
                            style={{ cursor: "pointer" }}
                            onClick={() => openModal(item, "duplicate")}
                          />
                        </CustomTooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </React.Fragment>
              ))}
      </React.Fragment>
        );
      });
  };

  const allMatterOption = { value: "", label: "All Matters" };
  const matterOptions = [
    allMatterOption,
    ...filteredMatters.filter((option) => option.value),
  ];
  const selectedMatterOption =
    matterOptions.find((option) => option.value === matter) || allMatterOption;

  return (
    <>
      <ToastContainer />

      {/* Single Workhour  */}
      <Snackbar
        open={singleDeleteSnackbarOpen}
        autoHideDuration={10000} // Hide after 10 seconds
        onClose={() => setSingleDeleteSnackbarOpen(false)}
        message="Selected time moved to Bin"
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }} // Change the position here
        action={
          <Button color="secondary" size="small" onClick={handleUndoSingle}>
            UNDO
          </Button>
        }
      />

      {/* Multiple Workhour  */}
      <Snackbar
        open={multipleDeleteSnackbarOpen}
        autoHideDuration={10000} // Hide after 10 seconds
        onClose={() => setMultipleDeleteSnackbarOpen(false)}
        message="Selected entries’ time moved to Bin"
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }} // Change the position here
        action={
          <Button color="secondary" size="small" onClick={handleUndoMultiple}>
            UNDO
          </Button>
        }
      />

      {/* Snackbar for Single Write-off */}
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }} // Change the position here
        open={singleWriteoffSnackbarOpen}
        autoHideDuration={10000} // Hide after 10 seconds
        onClose={() => setSingleWriteoffSnackbarOpen(false)}
        message="Single entry written off"
        action={
          <Button
            color="secondary"
            size="small"
            onClick={handleUndoWriteoffSingle}
          >
            UNDO
          </Button>
        }
      />

      {/* Snackbar for Multiple Write-offs */}
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }} // Change the position here
        open={multipleWriteoffSnackbarOpen}
        autoHideDuration={10000} // Hide after 10 seconds
        onClose={() => setMultipleWriteoffSnackbarOpen(false)}
        message="Multiple entries written off"
        action={
          <Button
            color="secondary"
            size="small"
            onClick={handleUndoWriteoffMultiple}
          >
            UNDO
          </Button>
        }
      />

      <BinTimeModal entries={binEntries} busy={binBusy}
        onClose={() => { if (!binBusy) setBinEntries([]); }} onSubmit={submitBinTime} />

      <CustomModal
        showModal={reviewerModalOpen}
        closeModal={() => { if (!reviewerReportBusy) setReviewerModalOpen(false); }}
        title="Master Reviewer Timespent"
        onSubmit={downloadReviewerTimespent}
        showButtons={false}
      >
        <Typography variant="body2">
          Period: {formattedStartDate} – {formattedEndDate}. Includes all resources’ time,
          grouped by assigned matter. Uses the current comments, discount, and write-off
          settings. Matters without entries for the selected report are skipped.
        </Typography>
        <Select
          aria-label="Reviewer"
          options={reviewerOptions}
          value={selectedReviewer}
          onChange={setSelectedReviewer}
          isDisabled={reviewerReportBusy || matterLoading || Boolean(matterError)}
          isLoading={matterLoading}
          placeholder="Select reviewer"
          menuPortalTarget={document.body}
          menuPosition="fixed"
          menuPlacement="auto"
          maxMenuHeight={220}
          styles={{
            ...customStyles,
            menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
          }}
        />
        {!matterLoading && !matterError && !reviewerOptions.length && <Typography variant="body2">{isReviewerLogin ? "Your reviewer name is unavailable." : "No employees with the Partner designation are available."}</Typography>}
        {matterError && <Typography color="error">Unable to load matter assignments. Close and reopen to retry.</Typography>}
        {selectedReviewer && <Typography variant="body2">{reviewerMatters.length} active assigned matter(s)</Typography>}
        {selectedReviewer && <Box sx={{ maxHeight: 160, overflowY: "auto" }}>
          {reviewerMatters.map((item) => <Typography key={item._id} variant="body2">{item.name} | {item.client?.name || ""}</Typography>)}
        </Box>}
        {reviewerReportBusy && <Typography role="status" variant="body2">Generating {reviewerReportProgress}</Typography>}
        <CustomButton type="submit" disabled={reviewerReportBusy || matterLoading || Boolean(matterError) || !selectedReviewer || !reviewerMatters.length}>
          {reviewerReportBusy ? "Generating PDF…" : "Download master PDF"}
        </CustomButton>
      </CustomModal>

      {/* Search Bar  */}
      <Paper elevation={0} className="rounded-full">
        <Grid container spacing={1} alignItems="center" marginBottom="1rem">
          {/* Main Heading  */}
          <Grid item container spacing={1} xs={12} sm={7} md={3}>
            <Grid item>
              <Typography variant="h5">Timespent</Typography>
            </Grid>
            <Grid item>
              <CustomTooltip text="Add Time">
                <CustomButton
                  style={{
                    borderRadius: "50%",
                    minWidth: "5px",
                    height: "30px",
                    transition:
                      "transform 0.3s ease-in-out, background-color 0.3s ease",
                    "&:hover": {
                      backgroundColor: "#886a47",
                      transform: "scale(1.1)",
                    },
                  }}
                  onClick={() => openModal(null, "add")}
                >
                  <AddIcon />
                </CustomButton>
              </CustomTooltip>
            </Grid>
          </Grid>

          {/* Matters  */}
          <Grid item xs={12} sm={7} md={2.5}>
            <Select
              options={matterOptions}
              value={selectedMatterOption}
              onChange={(e) => {
                setMatter(e.value);
                if (e.value) {
                  setSelectedMatterName(e.label.split("|")[0]);
                  setClient(e.label.split("|")[1]);
                } else {
                  setSelectedMatterName("");
                  setClient("");
                }
              }}
              isSearchable
              placeholder="All Matters"
              styles={customStyles}
            />
          </Grid>

          {/* Resources  */}
          <Grid item xs={12} sm={5} md={1.5}>
            <Select
              options={filteredEmployees}
              value={filteredEmployees.find(
                (resOption) => resOption.label === `${selectedLawyer}`
              )}
              onChange={(e) => {
                setSelectedLawyer(e.value);
              }}
              isSearchable
              placeholder="Resource"
              styles={customStyles}
            />
          </Grid>

          {/* Date Range Picker */}
          <Grid
            item
            xs={2}
            sm={2}
            md={2}
            display="flex"
            alignItems="center"
            gap={1}
          >
            <CustomTooltip text={"Select Dates"}>
              <CustomDateRangePicker
                startDate={selectedDateRange.start}
                endDate={selectedDateRange.end}
                onDateRangeChange={handleDateRangeChange}
                iconSize={30}
              />
            </CustomTooltip>

            <Typography>
              {formatMonthDate(startSelectedDate)} -{" "}
              {formatMonthDate(endSelectedDate)}
            </Typography>
          </Grid>

          {/* Master reviewer report */}
          <Grid item xs={4} sm={2} md={0.4}>
            <CustomTooltip text="Master reviewer Timespent PDF">
              <IconButton
                aria-label="Download master reviewer Timespent PDF"
                onClick={() => {
                  setSelectedReviewer(isReviewerLogin ? reviewerOptions[0] || null : null);
                  setReviewerModalOpen(true);
                  dispatch(fetchAllMatters());
                }}
                className=" text-black hover:bg-gray-800"
                style={{
                  padding: 5,
                  borderRadius: "50%",
                }}
              >
                <FolderOutlined style={{ fontSize: "20px" }} />
              </IconButton>
            </CustomTooltip>
          </Grid>

          {/* Show/Hide Comments Icon Button */}
          <Grid item xs={4} sm={2} md={0.4}>
            <CustomTooltip
              text={showComment ? "Hide Comments" : "Show Comments"}
            >
              <IconButton
                onClick={() => setShowComment(!showComment)}
                className=" text-black hover:bg-gray-800"
                style={{
                  padding: 5,
                  // color: "white",
                  // backgroundColor: "black",
                  borderRadius: "50%",
                }}
              >
                {showComment ? (
                  <IoMdEye style={{ fontSize: "20px" }} />
                ) : (
                  <BiSolidHide style={{ fontSize: "20px" }} />
                )}
              </IconButton>
            </CustomTooltip>
          </Grid>

          {/* Show/Hide Discount Icon Button */}
          <Grid item xs={4} sm={2} md={0.4}>
            <CustomTooltip
              text={showDiscount ? "Hide Discount" : "Show Discount"}
            >
              <IconButton
                onClick={() => {
                  setShowDiscount(!showDiscount);
                }}
                className=" text-black hover:bg-gray-800"
                style={{
                  padding: 5,
                  // color: "white",
                  // backgroundColor: "black",
                  borderRadius: "50%",
                }}
              >
                {showDiscount ? (
                  <TbDiscount style={{ fontSize: "20px" }} />
                ) : (
                  <TbDiscountOff style={{ fontSize: "20px" }} />
                )}
              </IconButton>
            </CustomTooltip>
          </Grid>

          {/* Download Icon Button */}
          <Grid item xs={4} sm={2} md={0.4}>
            <CustomTooltip text="Download Report">
              <IconButton
                onClick={() =>
                  generateTimeSpent(
                    false,
                    rightOffPdfEnabled ? "writeoff" : "timespent"
                  )
                }
                className=" text-black hover:bg-gray-800"
                style={{
                  padding: 5,
                  borderRadius: "50%",
                }}
              >
                <Download style={{ fontSize: "20px" }} />
              </IconButton>
            </CustomTooltip>
          </Grid>

          {/* Write off PDF Toggle Icon Button */}
          <Grid item xs={4} sm={2} md={0.4}>
            <CustomTooltip
              text={
                rightOffPdfEnabled
                  ? "Disable Write off PDF"
                  : "Enable Write off PDF"
              }
            >
              <IconButton
                onClick={() => setRightOffPdfEnabled(!rightOffPdfEnabled)}
                className=" text-black hover:bg-gray-800"
                style={{
                  padding: 5,
                  borderRadius: "50%",
                }}
              >
                {rightOffPdfEnabled ? (
                  <AttachMoney style={{ fontSize: "20px" }} />
                ) : (
                  <MoneyOffCsred style={{ fontSize: "20px" }} />
                )}
              </IconButton>
            </CustomTooltip>
          </Grid>

          {/* Send Email Icon Button */}
          <Grid item xs={4} sm={2} md={0.4}>
            <CustomTooltip text="Send Report via Email">
              <IconButton
                onClick={() => setEmailModalOpen(true)}
                className=" text-black hover:bg-gray-800"
                style={{
                  padding: 5,
                  borderRadius: "50%",
                }}
              >
                <Email style={{ fontSize: "20px" }} />
              </IconButton>
            </CustomTooltip>
          </Grid>
        </Grid>

        {selectedEntries.length > 1 && (
          <Grid container spacing={1} alignItems="baseline" marginY="1rem">
            <Grid item xs={12} sm={7} md={3}>
              <Select
                options={filteredMatters}
                value={filteredMatters.find(
                  (option) =>
                    option.label === `${newSelectedMatterName} | ${newClient}`
                )}
                onChange={(e) => {
                  setNewMatter(e.value);
                  setNewSelectedMatterName(e.label.split("|")[0]);
                  setNewClient(e.label.split("|")[1]);
                }}
                isSearchable
                placeholder="Select New Matter"
                styles={customStyles}
              />
            </Grid>

            <Grid item xs={4} sm={4} md={0.5}>
              <CustomTooltip text="Move all">
                <IconButton onClick={() => handleUpdateEntries()}>
                  <DriveFileMoveOutlinedIcon style={{ fontSize: "25px" }} />
                </IconButton>
              </CustomTooltip>
            </Grid>

            <Grid item xs={12} sm={4} md={0.5}>
              <CustomTooltip text="Move all to Bin">
                <IconButton onClick={() => handleSoftDeleteMultiple()}>
                  <RiDeleteBin6Line style={{ fontSize: "25px" }} />
                </IconButton>
              </CustomTooltip>
            </Grid>

            <Grid item xs={12} sm={4} md={0.5}>
              <CustomTooltip text="Write-off all">
                <IconButton onClick={() => handleWriteoffMultiple()}>
                  <TbDiscount2Off style={{ fontSize: "25px" }} />
                </IconButton>
              </CustomTooltip>
            </Grid>
          </Grid>
        )}
      </Paper>

      {/* Modal  */}
      {showModal && (
        <CustomModal
          showModal={showModal}
          closeModal={closeModal}
          title="Add Time" // Dynamic title
          onSubmit={handleSubmit}
          showButtons={false}
        >
          <div className="flex gap-4 w-full">
            <div style={{ width: "50%" }}>
              <input
                type="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
              />
            </div>

            <div style={{ width: "50%" }}>
              <Select
                options={filteredEmployees}
                value={filteredEmployees.find(
                  (resOption) =>
                    resOption.label === `${modalSelectedLawyerName}`
                )}
                onChange={(e) => {
                  setModalSelectedLawyerId(e.value);
                  setModalSelectedLawyerName(e.label);
                }}
                isSearchable
                placeholder="Select Resource"
                styles={customStyles}
              />
            </div>
          </div>

          <div className="flex gap-4 w-full">
            <div style={{ width: "100%" }}>
              {modalSelectedMatterName}

              <Select
                options={filteredMatters}
                value={filteredMatters.find(
                  (option) =>
                    option.label ===
                    `${modalSelectedMatterName} | ${modalClient}`
                )}
                onChange={(e) => {
                  setModalMatter(e.value);
                  setModalSelectedMatterName(e.label.split("|")[0]);
                  setModalClient(e.label.split("|")[1]);
                }}
                isSearchable
                placeholder="Select Matter"
                styles={customStyles}
              />
            </div>
          </div>

          <div className="flex gap-4 w-full">
            <div style={{ width: "50%" }}>
              <select
                value={workHour}
                name="workHour"
                onChange={(event) => {
                  setWorkHour(event.target.value);
                }}
              >
                <option value="">Select Work Hour *</option>
                {Array.from({ length: 19 }, (_, i) => (
                  <option key={i} value={i}>
                    {i}
                  </option>
                ))}
              </select>
            </div>

            <div style={{ width: "50%" }}>
              <select
                value={workMin}
                name="workMin"
                onChange={(event) => {
                  setWorkMin(event.target.value);
                }}
              >
                <option value="">Select Work Minutes *</option>
                {Array.from({ length: 10 }, (_, i) => (
                  <option key={i * 6} value={i * 6}>
                    {i * 6}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* <div className="flex gap-4 w-full">
            <textarea
              type="text"
              placeholder="Work description"
              value={workDescription}
              onChange={(e) => setWorkDescription(e.target.value)}
            />
          </div> */}

          <div className="flex gap-4 w-full">
            <input
              type="text"
              style={{ width: "100%" }}
              placeholder="Comments for the reviewer"
              value={comments}
              onChange={(e) => setComments(e.target.value)}
            />
          </div>

          <textarea
            ref={descRef}
            defaultValue={workDescription}
            onBlur={handleBlur}
            placeholder="Work description"
            style={{ width: "100%", minHeight: "80px" }}
          />

          {/* Redraft button, show only if aiSuggestion is not present */}
          {!aiSuggestion && (
            <div className="flex gap-4 w-full justify-end">
              <CustomTooltip text="Redraft with AI">
                <CustomButton
                  style={{ width: "100%" }}
                  onClick={redraftWithAI}
                  disabled={isRetryingAi} // Disable when retrying
                >
                  <HiSparkles size={18} style={{ marginRight: "5px" }} />
                  Redraft
                </CustomButton>
              </CustomTooltip>
            </div>
          )}

          {/* AI suggested description with Retry button */}
          {aiSuggestion && (
            <>
              <Typography variant="body2">AI Suggested</Typography>
              <div style={{ position: "relative" }}>
                <textarea
                  style={{
                    height: 80,
                    width: "100%",
                    backgroundColor: "#f0f0f0",
                    paddingRight: "40px",
                    resize: "none",
                  }}
                  value={isRetryingAi ? "Revising again..." : aiSuggestion}
                  onChange={(e) => setAiSuggestion(e.target.value)}
                  disabled={isRetryingAi}
                />
                {/* Retry button positioned inside the textarea container */}
                <CustomTooltip text="Retry" placement="top" arrow="">
                  <IconButton
                    onClick={retryAiSuggestion}
                    style={{
                      position: "absolute",
                      right: "5px",
                      top: "5px",
                      color: isRetryingAi ? "gray" : "#555",
                    }}
                    disabled={isRetryingAi}
                  >
                    <TfiReload style={{ fontSize: "20px" }} />
                  </IconButton>
                </CustomTooltip>
              </div>
            </>
          )}

          <div className="flex justify-center align-middle gap-3">
            <CustomButton onClick={handleSubmit}>Submit</CustomButton>
            {aiSuggestion && (
              <CustomButton onClick={onSubmitWithAiSuggestion}>
                Submit Revised
              </CustomButton>
            )}
            <CustomButton
              variant="outlined"
              style={{ width: "30%" }}
              onClick={closeModal}
            >
              Cancel
            </CustomButton>
          </div>
        </CustomModal>
      )}

      {/* Main Table  */}
      <Paper sx={{ width: "100%", overflow: "hidden" }}>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100, 500, 1000]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        <TableContainer sx={{ maxHeight: "66vh" }}>
          <Table aria-label="reusable table">
            <TableHead>
              <TableRow>
                <TableCell colSpan={columns.length + 1}>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    {/* Left side: icon + title */}
                    <Box display="flex" alignItems="center">
                      {recentEntries ? (
                        <HistoryIcon
                          fontSize="small"
                          style={{ marginRight: 8 }}
                        />
                      ) : (
                        <FilterListIcon
                          fontSize="small"
                          style={{ marginRight: 8 }}
                        />
                      )}
                      <Typography variant="h6">
                        {recentEntries ? "Recent Entries" : "Filtered Entries"}
                      </Typography>
                    </Box>

                    {/* Right side: your Date-First switch */}
                    <FormControlLabel
                      control={
                        <Switch
                          checked={dateGroupView}
                          onChange={() => setDateGroupView((v) => !v)}
                        />
                      }
                      label="Date-First View"
                    />
                  </Box>
                </TableCell>
              </TableRow>
              <TableRow sx={{ height: "5px" }}>
                <TableCell colSpan={12}>
                  <div className="middle">
                    <div style={{ display: "flex", gap: "10px" }}>
                      <label>Total amount for above period :</label>
                      <p>
                        {currency}
                        {parseFloat(totalAmountForSelectedPeriod)
                          ?.toFixed(2)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      </p>
                    </div>
                    <div style={{ display: "flex", gap: "10px" }}>
                      <label>Total Hours for above period: </label>
                      <p>
                        {parseFloat(totalHoursForSelectedPeriod)?.toFixed(2)}
                      </p>
                    </div>
                    <div style={{ display: "flex", gap: "10px" }}>
                      <label> Total unbilled amount : </label>
                      <p>
                        {currency}
                        {parseFloat(totalUnbilledAmount)
                          ?.toFixed(2)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        {moment(lastSentInvoiceDate, "YYYY-MM-DD", true).isValid() &&
                          ` (Since ${moment(lastSentInvoiceDate, "YYYY-MM-DD").format("D MMM YYYY")})`}
                      </p>
                    </div>
                    {showDiscount && (
                      <div style={{ display: "flex", gap: "10px" }}>
                        <label>Total discounted hours: </label>
                        <p>{parseFloat(totalDiscount)?.toFixed(2)}</p>
                      </div>
                    )}
                  </div>
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell id="table-header">
                  <CustomTooltip text="Select All">
                    <input
                      type="checkbox"
                      className="custom-checkbox"
                      checked={selectAll}
                      onChange={(e) => handleSelectAll(e)}
                    />
                  </CustomTooltip>
                </TableCell>
                {columns.map((column, index) => (
                  <TableCell key={index} id="table-header">
                    {column}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {totalCount === 0 ? (
                <TableRow>
                  <TableCell colSpan={columns.length + 1}>
                    <NoDataFound message="No entries found." />
                  </TableCell>
                </TableRow>
              ) : dateGroupView ? (
                renderDateGroupedRows()
              ) : (
                renderRows()
              )}
            </TableBody>
          </Table>

          <DiscountModal
            open={openDiscountModal}
            onClose={handleModalClose}
            onSubmit={handleDiscountSubmit}
            itemId={selectedItemId}
            initialDiscount={selectedItemWorkHours} // Pass the work hours of the selected item
            existingWorkHours={selectedItemWorkHours} // Pass the existing work hours
          />
        </TableContainer>
      </Paper>

      {/* Email Modal */}
      <Modal
        open={emailModalOpen}
        onClose={() => {
          setEmail("");
          setEmailModalOpen(false);
        }}
      >
        <Paper
          style={{
            width: "400px",
            margin: "auto",
            marginTop: "20vh",
            padding: "20px",
          }}
        >
          <Typography variant="h6">Send Report via Email</Typography>
          <TextField
            fullWidth
            label="Recipient Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ marginTop: "10px" }}
          />
          <div style={{ marginTop: "20px", display: "flex", gap: "10px" }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSendEmail}
              disabled={!email}
            >
              {loading ? "Sending..." : "Send"}
            </Button>
            <Button variant="outlined" onClick={() => setEmailModalOpen(false)}>
              Cancel
            </Button>
          </div>
        </Paper>
      </Modal>
    </>
  );
};

export default TimeSpent;
